import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { ScrollButton } from './ui/ScrollButton';
export const ContrastTable = () => {
  const badPoints = ['Mandás presupuestos y silencio total', 'Cuando te dicen "no tengo plata" no sabés qué responder', 'Tus clientes dicen "dejame pensarlo" y desaparecen', 'Tu último cliente fue hace más de 3 semanas', 'Bajás el precio cada vez que sienten resistencia', 'Sabés que tenés que hacer algo pero no sabés qué', 'Perdés ventas en el 1er "no" del cliente'];
  const goodPoints = ['Tus propuestas generan respuesta en 48 hs', 'Tenés un guion probado para cada objeción', 'Sabés exactamente qué decir para que decidan', 'Tenés un sistema de reactivación corriendo siempre', 'Justificás el valor y cerrás sin descuentos', 'Tenés un plan de 30 días, día por día', 'Sabés que el 80% se cierra después del 5to contacto'];
  return <section className="py-24 bg-cream" data-id="element-83">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-84">
        <div className="text-center mb-16" data-id="element-85">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-86">
            Lo que está pasando hoy vs. lo que debería estar pasando
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-87">
          {/* Bad Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-6 sm:p-8 border border-neutral-200 shadow-sm" data-id="element-88">
            <div className="flex items-center gap-3 mb-8 pb-4 border-b border-neutral-100" data-id="element-89">
              <XCircle className="w-8 h-8 text-neutral-400" data-id="element-90" />
              <h3 className="text-2xl font-bold text-neutral-700" data-id="element-91">
                HOY (Sin el sistema)
              </h3>
            </div>
            <ul className="space-y-6" data-id="element-92">
              {badPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-neutral-600" data-id="element-93">
                  <span className="text-neutral-400 mt-1" data-id="element-94">❌</span>
                  <span className="text-lg leading-snug" data-id="element-95">{point}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Good Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-600 rounded-xl p-6 sm:p-8 shadow-md" data-id="element-96">
            <div className="flex items-center gap-3 mb-8 pb-4 border-b border-brand-500/50" data-id="element-97">
              <CheckCircle2 className="w-8 h-8 text-white" data-id="element-98" />
              <h3 className="text-2xl font-bold text-white" data-id="element-99">
                CON CAJA DE COBRO
              </h3>
            </div>
            <ul className="space-y-6" data-id="element-100">
              {goodPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-brand-50" data-id="element-101">
                  <span className="text-white mt-1" data-id="element-102">✅</span>
                  <span className="text-lg font-medium leading-snug" data-id="element-103">
                    {point}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto" data-id="element-104">
          <p className="text-xl font-medium text-neutral-700 mb-8" data-id="element-105">
            Si te identificás con 3 o más de la columna izquierda, lo que viene
            cambia todo.
          </p>
          <ScrollButton className="w-full sm:w-auto" data-id="element-106">
            QUIERO DEJAR DE PERDER VENTAS →
          </ScrollButton>
        </motion.div>
      </div>
    </section>;
};